import React, {useState} from 'react';
import './styles.scss';
import {connect} from 'react-redux';
import {
  addToGlobalStyles,
  addToWizard,
  setWizard,
  setSelectedBu,
  setAvailableBus,
  setDigitalCommunications,
  setGlobalStyles,
} from '../../../store/actions';
import {compose} from 'redux';
import AppButton from '../../../components/app-button';
import RegisterHeader from '../../../components/headers/register-header';
import {Column, Row} from '../../../components/layout';
import Header1 from '../../../components/headers/header1';
import {strings} from '../../../util/strings';
import * as fonts from '../../../util/fonts';
import colors from '../../../util/colors';
import {useHistory} from 'react-router-dom';
import {uriUpdateDigitalCommunications} from '../../../api/endpoints';
import {put} from '../../../api/api';
import ModalTemplate from '../../../components/modal';
import AppParagraph from '../../../components/app-paragraph';
import Header2 from '../../../components/headers/header2';
import {createGUID, labelsParagraphs} from '../../../util/utility';
import {AuthConsumer} from '../../../providers/AuthProvider';
import FooterWaveLogin from '../../../components/footer/footer-wave';
import {ITenant} from '../../../App';

export interface DataTreatmentProps {
  wizard: any;
  selectedBu: any;
  user: any;
  stringsDefault: any;
  stringsDefaultMessages: any;
  globalStyles: any;
  tenant: ITenant;
  showPersonalDate: boolean;
  addToWizard(value: any): void;
  addToGlobalStyles(value: any): void;
  setGlobalStyles(value: any): void;
  setSelectedBu(value: any): void;
  setAvailableBus(value: any): void;
  setDigitalCommunications(value: any): void;
}

const InsuranceInYourHands = (props: any) => {
  const [showModal, setShowModal] = useState(false);
  const [showError, setShowError] = useState(false);
  const history = useHistory();

  const featureName = 'InsuranceInYourHands';
  labelsParagraphs(props.stringsDefault);

  const proceed = async (option: boolean) => {
    try {
      await put(
        uriUpdateDigitalCommunications(props.user.nif),
        {propValue: option},
        featureName
      );

      if (
        props.wizard.skipDataTreatment ||
        !props.tenant.loginFlow.dataTreatment
      ) {
        history.push('/inicio');
      } else {
        history.push('/tratamento-dados');
      }
    } catch (e: any) {
      setShowError(true);
    } finally {
      props.setDigitalCommunications(option ? 'True' : 'False');
    }
  };

  return (
    <AuthConsumer>
      {() => (
        <>
          <RegisterHeader />
          <Column className="register-main-column">
            <Column className="register-container">
              <Row className="register-header-row">
                <Header1
                  style={{
                    ...fonts.XL,
                    color: colors.black,
                  }}
                  className="register-header-title">
                  {props.stringsDefault?.insurance_title_firstLine}
                  <br />
                  {props.stringsDefault?.insurance_title_secondLine}
                </Header1>
              </Row>
              <div className="data-treatment-body-container">
                <div className="data-treatment-description">
                  {props.stringsDefault?.insurance_description}
                </div>
                <div className="data-treatment-description see-more">
                  <p>
                    {props.stringsDefault?.insurance_seeMore}{' '}
                    <a
                      className="accept-link"
                      style={{color: props.globalStyles?.primaryColor}}
                      onClick={() => setShowModal(true)}>
                      {props.stringsDefault?.insurance_seeMoreLink}
                    </a>
                  </p>
                </div>
              </div>
              <p className="delimiter"></p>
              <Column className="register-row">
                <AppButton
                  className="register-button left"
                  variant="primary"
                  onClick={async () => {
                    proceed(true);
                    // NOTE: Leaving old code commented in case we need to revert (if this is here after a long time just delete it)
                    // try {
                    //   await put(
                    //     uriUpdateDigitalCommunications(props.user.nif),
                    //     {propValue: true},
                    //     featureName
                    //   );
                    //   if (props.showPersonalDate) {
                    //     history.push('/confirmar-dados-pessoais');
                    //   } else {
                    //     history.push('/inicio');
                    //   }
                    // } catch (e: any) {
                    //   setShowError(true);
                    // } finally {
                    //   props.setDigitalCommunications('True');
                    // }
                  }}>
                  {props.stringsDefault?.insurance_accept}
                </AppButton>
                <div className="decline-wrapper">
                  <a
                    className="decline-content"
                    style={{color: props.globalStyles?.primaryColor}}
                    onClick={async () => {
                      proceed(false);
                    }}>
                    {props.stringsDefault?.insurance_decline}
                  </a>
                </div>
              </Column>
            </Column>
            <ModalTemplate
              className="moreinfo-modal"
              show={showModal}
              onHide={() => setShowModal(false)}
              hideFooter={true}
              cross={true}>
              <Row>
                <Header2
                  style={{...fonts.Bold, ...fonts.XL, color: colors.black}}
                  className="moreinfo-modal-header">
                  {props.stringsDefault?.insurance_moreInfo}
                </Header2>
              </Row>
              <Column className="moreinfo-modal-info">
                <AppParagraph
                  label={props.stringsDefault?.insurance_moreInfoDescription}
                />
              </Column>
              <Row className="moreinfo-modal-button">
                <AppButton
                  variant="secondary"
                  onClick={() => setShowModal(false)}>
                  {props.stringsDefault?.insurance_moreInfoButton}
                </AppButton>
              </Row>
            </ModalTemplate>
            <ModalTemplate
              className="error-modal"
              contentClassName="error-modal-content"
              size="sm"
              show={showError}
              onHide={() => setShowError(false)}
              hideFooter={true}
              cross={true}
              title={props.stringsDefaultMessages.apiError_digitalCom_webTitle}
              type="error"
              titleStyle={{
                ...fonts.L,
                color: colors.black,
                ...fonts.SemiBold,
                textAlign: 'center',
              }}>
              <Column>
                <Row>
                  <p
                    className="error-modal-alert"
                    style={{...fonts.Medium, color: colors.alertRed}}>
                    {' '}
                    {props.stringsDefaultMessages.apiError_digitalCom_title}
                  </p>
                </Row>
                <Row>
                  <p className="error-modal-description">
                    {' '}
                    {
                      props.stringsDefaultMessages
                        .apiError_digitalCom_description
                    }
                  </p>
                </Row>
                <Row>
                  <AppButton
                    onClick={() => {
                      history.push('/inicio');
                    }}>
                    Ok
                  </AppButton>
                </Row>
              </Column>
            </ModalTemplate>
          </Column>
          <FooterWaveLogin color={props.globalStyles?.primaryColor} />
        </>
      )}
    </AuthConsumer>
  );
};

const mapStateToProps = ({
  wizard,
  selectedBu,
  user,
  strings,
  stringsDefault,
  stringsDefaultMessages,
  globalStyles,
  tenant,
  showPersonalDate,
}: any) => ({
  wizard: wizard.value,
  selectedBu: selectedBu.value,
  user: user.value,
  labels: strings.value.pt.login,
  stringsDefault: stringsDefault.value.pt.login,
  stringsDefaultMessages: stringsDefault.value.pt.messages,
  globalStyles: globalStyles.value,
  tenant: tenant.value,
  showPersonalDate: showPersonalDate.value,
});

const mapDispatchToProps = (dispatch: any) => ({
  setWizard: (value: any) => dispatch(setWizard(value)),
  addToWizard: (value: any) => dispatch(addToWizard(value)),
  addToGlobalStyles: (value: any) => dispatch(addToGlobalStyles(value)),
  setGlobalStyles: (value: any) => dispatch(setGlobalStyles(value)),
  setSelectedBu: (value: any) => dispatch(setSelectedBu(value)),
  setAvailableBus: (value: any) => dispatch(setAvailableBus(value)),
  setDigitalCommunications: (value: any) =>
    dispatch(setDigitalCommunications(value)),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps)(InsuranceInYourHands)
);
